import { render, staticRenderFns } from "./sparkline-chart.vue?vue&type=template&id=520bcd08"
import script from "./sparkline-chart.vue?vue&type=script&lang=js"
export * from "./sparkline-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports